/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: "",
    // Relative to /src/views
    view: "Empty",
  },
  {
    path: "/user-profile",
    name: "User Profile",
    view: "UserProfile",
  },
  {
    path: "/table-list",
    name: "Table List",
    view: "TableList",
  },
  {
    path: "/typography",
    view: "Typography",
  },
  {
    path: "/icons",
    view: "Icons",
  },
  {
    path: "/maps",
    view: "Maps",
  },
  {
    path: "/notifications",
    view: "Notifications",
  },
  {
    path: "/upgrade",
    name: "Upgrade to PRO",
    view: "Upgrade",
  },
  {
    path: "/taxi-fare-calculator",
    name: "TaxiFare",
    view: "TaxiFare",
  },
  {
    path: "/cat-generator",
    name: "CatGenerator",
    view: "CatGif",
  },
  {
    path: "/what-is-my-ip-address",
    name: "WhatIsMyIP",
    view: "MyIp",
  },
  {
    path: "/colorpicker",
    name: "ColorPicker",
    view: "ColorPicker",
  },
  {
    path: "/checklist",
    name: "CheckList",
    view: "CheckList",
  },
  {
    path: "/private/chat",
    name: "Login",
    view: "Login",
  },
  {
    path: "/private/connect",
    name: "Connect",
    view: "Showqr",
  },
  {
    path: "/private/error",
    name: "Nosignal",
    view: "Nosignal",
  },
  {
    path: "/private/gate",
    name: "Entrance",
    view: "Entrance",
  },
];
